import React from 'react'
import './hero.css';
export default function Hero() {
    return (
        <div className='hero-container'>
            <div className="hero-text">
                <div className="top-text">
                    <h1 className="hero-heading">
                        Protect Your Investment with an Extended Warranty
                    </h1>
                    <p className="hero-subheading">
                        Get a personalized quote in seconds.
                    </p>
                    <button>Get My Warranty Quote</button>
                </div>
                <div className="dynamic-container">
                    <div className="search-box">
                        <i className='bx bx-search'></i>
                        <input type="search" placeholder='Search VIN' name="search" id="" />
                    </div>
                    <button>Check Warranty</button>
                </div>
            </div>
            <div className="hero-image">
                <img src="car-picture/single_toyota_car__1_-removebg-preview (1).png" alt="" />
            </div>
        </div>
    )
}
